import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, List } from "semantic-ui-react";
import Axios from "axios";
import cogoToast from "cogo-toast";
import { LOCAL_STORAGE, INVALID_MESSAGES,PROMPTS } from "../../config/const";
import {TITLE,BUTTONS,LABELS} from './importModalConstants'

const ImportModal = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [importMsg, setImportMsg] = useState([]);
  const [showResultModal, setShowResultModal] = useState(false);
  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = () => {
    let customerNo = LOCAL_STORAGE.customerNo
    let fileName = `${props.fileName}.xlsx`;
    let url=`${process.env.REACT_APP_BASE_URL}/masters/templateDownload/${customerNo}/${fileName}`;
    
    Axios.get(url,{
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `${LOCAL_STORAGE.userToken}`,
      },
      responseType:'blob'}).then((res)=>{
      var data = new Blob([res.data]);
      
        var blob = data;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click(); 
      })
}

  const handleResultModalClose = () => {
    setImportMsg([]);
    setShowResultModal(false);
  }

  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
      cogoToast.error(INVALID_MESSAGES.IVALID_FILE)
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
      cogoToast.error(INVALID_MESSAGES.INVALID_FILE_FORMAT)
    } else {
      let fromData = new FormData();
      fromData.append("myfile", file);
      fromData.append("customerNumber", LOCAL_STORAGE.customerNo);
      fromData.append("userId", LOCAL_STORAGE.userId);
      props.moduleName && fromData.append("module", props.moduleName) ;
      var gett = LOCAL_STORAGE.userToken
      var url = `${process.env.REACT_APP_BASE_URL}/masters/import/${props.baseURL}`;
      Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          if (response.data.status === 200) {
            if (response.data.resultSet.length > 0) {
              setShowResultModal(true)
              setImportMsg(response.data.resultSet)

            } else {
              setisloading(false);
              cogoToast.error(PROMPTS.NO_RECORDS_FOUND, { position: 'top-right'})
              window.setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          }
          setisloading(false);
          // props.handleClose();
        })
        .catch((err) => {
          cogoToast.error(err.response.data.message, { position: 'top-right'})
          setisloading(false);
        });
    }
  };

  return (
    <div>
      {importMsg.length > 0 ?
        <>
          <Modal open= {showResultModal} onClose={handleResultModalClose}>
            <div style={{ height: '200px', overflowY: 'scroll', padding: '20px' }}>
                {importMsg.map((o, i) => (
                    <>
                        <List className="p-2 pl-2 m-1 w3-border w3-border-blue">
                            <List.Item >
                                <List.Description> {`Record ${i + 1}:`}</List.Description>
                                <List.Header>{typeof o.message === 'object' ? o.message?.message : o.message}</List.Header>
                            </List.Item>
                        </List>
                    </>
                ))}
            </div>
            <center><button onClick={() => window.location.reload()} className="w3-button w3-small w3-blue w3-round w3-hover-blue p-outline-none m-2">{"OK"}</button></center>
          </Modal>
        </>
        :
      <>

      <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
        <Header>{TITLE||"Import File"}</Header>
        <Modal.Content>
          <Modal.Description>
            <FormUi.Group inline>
              <FormUi.Field>
                <label className="tiny ui form p-bold-600">
                  {LABELS.import_excel||"Import Data Using Excel Sheet(Format- xls,xlsx)."}
                </label>
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field>
                <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                { LABELS.upload_file||"Upload File"} &nbsp;
                </label>
                <input
                  onChange={handleFile}
                  type="file"
                  className="w3-small"
                  id="validatedCustomFile"
                />
              </FormUi.Field>
              <FormUi.Field>
                <label className="tiny ui form pt-3">
                  <span className="p-bold-600 ">
                  {LABELS.download_template||"Download Excel Template from"}{" "}
                    <span
                      className="w3-text-blue p-bold-300"
                      onClick={templateDownload}
                      style={{ cursor: "pointer" }}
                    >
                      { LABELS.here||"Here"}
                    </span>
                  </span>
                </label>
              </FormUi.Field>
            </FormUi.Group>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isloading ? <small>{PROMPTS.LOADING||"Loading..."}</small> : ""}
          <Button onClick={props.handleClose} size="mini">
          {BUTTONS.cancel||"Cancel"}
          </Button>
          <Button
            onClick={handleUpload}
            disabled={isloading ? true : false}
            color="blue"
            size="mini"
          >
            {BUTTONS.upload||"Upload"}
          </Button>
        </Modal.Actions>
      </Modal>
      </>}
    </div>
  );
};

export default ImportModal
